import { Box, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { ModelVersionSelect } from 'src/components/molecules/ModelVersionSelect';
import { SelectedModel } from 'src/components/molecules/ModelVersionSelect/SelectedModel';
import { useAppContext } from 'src/contexts/AppContext';
import { useFilterContext } from 'src/contexts/FilterContext';
import { ModelVersion } from 'src/contexts/FilterContext/useModelVersions';
import { useActiveRoute } from 'src/hooks/useActiveRoute';

/**
 * Sidebar slot for the model version selector. On routes without a service
 * (Goals, Inbox, Settings...) FilterContext resets the current model, so the
 * selector renders an inert snapshot of the last selection instead of the
 * interactive menu.
 */
export const SidebarModelSelect = () => {
  const { activeRoute } = useActiveRoute();
  const { currentModelVersion } = useFilterContext();
  const { currentCustomer } = useAppContext();

  const [lastModelVersion, setLastModelVersion] = useState<ModelVersion | null>(
    null,
  );

  useEffect(() => {
    setLastModelVersion(null);
  }, [currentCustomer?.customerName]);

  useEffect(() => {
    if (currentModelVersion) {
      setLastModelVersion(currentModelVersion);
    }
  }, [currentModelVersion]);

  const isModelPage = !!activeRoute?.service;

  return (
    <Box px="4" pb="4">
      {isModelPage ? (
        <ModelVersionSelect />
      ) : (
        <Box
          aria-disabled="true"
          opacity={0.6}
          pointerEvents="none"
          px="14px"
          py="8px"
          borderRadius="lg"
          borderWidth="1px"
          borderColor="surface.border"
          bg="surface.sidebarMuted">
          {lastModelVersion ? (
            <SelectedModel model={lastModelVersion} />
          ) : (
            <>
              <Text fontSize="sm" color="sidebar.textMuted">
                No model selected
              </Text>
              <Text mt="4px" fontSize="xs" color="sidebar.textMuted">
                —
              </Text>
            </>
          )}
        </Box>
      )}
    </Box>
  );
};
